"use client";

import { useAudioAnalyser } from "@/hooks/useAudioAnalyser";

const BAR_COUNT = 20;
const MIN_HEIGHT = 4;
const MAX_HEIGHT = 32;
const MIN_OPACITY = 0.3;

interface WaveformAnimationProps {
  stream: MediaStream | null;
}

export default function WaveformAnimation({ stream }: WaveformAnimationProps) {
  const audioLevels = useAudioAnalyser(stream, BAR_COUNT);

  return (
    <div className="flex items-center justify-center gap-1 h-12">
      {audioLevels.map((level, i) => {
        const height = MIN_HEIGHT + level * (MAX_HEIGHT - MIN_HEIGHT);
        const opacity = MIN_OPACITY + level * (1 - MIN_OPACITY);

        return (
          <div
            key={i}
            className="w-1 rounded-full bg-accent"
            style={{ height: `${height}px`, opacity }}
          />
        );
      })}
    </div>
  );
}
